import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    const playBtn = document.getElementById("play-video") as HTMLElement;
    const thumbnail = document.getElementById("video-thumbnail") as HTMLElement;
    const video = document.getElementById("video") as HTMLIFrameElement;

    playBtn?.addEventListener("click", () => {
      if (video) {
        video.src = "https://www.youtube.com/embed/nqHKPZ2m8XE?autoplay=1";
        video.style.display = "block";
      }
      if (thumbnail) thumbnail.style.display = "none";
    });
  }
}